export class AutocompleteItem {
  constructor(
    public id: AutocompleteItemId = null,
    public name: string = null
  ) { }
}

export type AutocompleteItemId = string;



// WEBPACK FOOTER //
// /dist/src/app/shared/autocomplete/autocomplete-item.model.ts